import React from "react";
import {FaTwitter,FaFacebookF,FaYoutube} from 'react-icons/fa';
import { useSelector } from "react-redux";
import { lang } from "../../../../config/app.config";
import { TranslationState } from "../../../../store/ActionReducers/translation.actionreducer";
// import translate from '../../../../translation.json';

const FooterSocial:React.FC = () =>{

  const state = useSelector((state:{translation:TranslationState})=>state.translation);

  return(
    <>
      <h3 className="text-16-white">{state.translation?state.translation.social_media_links[lang === 'np'?'value_np':'value_en']:''}</h3>
      <ul className="social">
        <li>
          <a href="https://twitter.com/ECNOfficial" target="_blank" rel="noreferrer"><FaTwitter/></a>
        </li>
        <li>
          <a href="https://www.facebook.com/ecnofficial/" target="_blank" rel="noreferrer"><FaFacebookF/></a>
        </li>
        <li>
          <a href="https://www.youtube.com/channel/UCQ1iYWQDmp5cAB-bb-107AQ"  target="_blank" rel="noreferrer"><FaYoutube/></a>
        </li>
      </ul>
    </>
  );
}

export default FooterSocial;
